<div class="po-wrapper">
  @if (isLoggedIn$ | async) {
    <po-toolbar p-title="Ecco Contab." [p-profile]="profile"
      [p-profile-actions]="profileActions" [p-show-notification]="true" [p-actions]="notificationActions"
      [p-notification-actions]="notificationActions2" [p-notification-number]="2" [p-show-notification]="true">
    </po-toolbar>
  }
  @if (isLoggedIn$ | async) {
    <po-menu #poMenu p-logo-alt="Devplus ERP - Cloud" p-logo="{{logo}}"
      p-short-logo="{{logo}}" [p-filter]="true" [p-collapsed]="true" [p-menus]="menus">
      <div *p-menu-header-template class="menu-header">
        <div class="menu-header-avatar">
          <i class="an an-user-circle"></i>
        </div>
        <div class="menu-header-info">
          <span class="menu-header-greeting">Bem-vindo,</span>
          <span class="menu-header-name">{{userInfo?.name}}</span>
        </div>
      </div>
    </po-menu>
  }
  <router-outlet></router-outlet>
</div>
